<template>
  <div>
    <Accordion :initShow="einzugsgebiet?.tgArray.length > 4 ? false : true" >
      <template v-slot:heading>
        <span class="popup-heading" v-text="`Einzugsgebiet für '${einzugsgebiet?.SEBezeichnung}'`"></span>
      </template>
      <div v-if="einzugsgebiet?.groesseGesamt">
        <span>Größe gesamt: </span><span>{{ einzugsgebiet?.groesseGesamt.toLocaleString("de-DE", {minimumFractionDigits: 2}) }}	ha</span>
      </div>
      <div v-if="einzugsgebiet?.groesseOhneEigenTG">
        <span>Größe ohne eigenes Teilgebiet: </span><span>{{ einzugsgebiet.groesseOhneEigenTG.toLocaleString("de-DE", {minimumFractionDigits: 2}) }}	ha</span>
      </div>
      <div v-if="einzugsgebiet?.warn">
        <span style="color: red">{{ einzugsgebiet.warn }}</span>
      </div>
      <table v-for="(item, index) in einzugsgebiet?.tgArray" :key="index" class="popup-table">
        <Accordion :initShow="false">
          <template v-slot:heading>
            <span class="popup-heading" v-text="`${item?.get('ID_TG_Typ')} '${item?.get('ID_SEBezeichnung')}'`"></span>
          </template>
          <tr v-if="item?.get('ID_TG_Bezeichnung') && item?.get('ID_TG_Bezeichnung') !== ''">
            <td>Bezeichnung: </td><td v-text="item?.get('ID_TG_Bezeichnung')"></td>
          </tr>
          <tr v-if="item?.get('ID_TG_Groesse_ha')">
            <td>Größe: </td><td> {{ item?.get('ID_TG_Groesse_ha')?.toLocaleString("de-DE", {minimumFractionDigits: 2}) }} ha</td>
          </tr>
        </Accordion>
      </table>
      <span v-if="einzugsgebiet?.tgArray.length == 0">Kein Einzugsgebiet eingetragen</span>
    </Accordion> 
  </div>
</template>

<script lang="ts">

import { onMounted, ref, computed, watch } from 'vue';
import Constants from './Constants';
import Accordion from "../../../vueforms/src/components/base/Accordion.vue";

export default {
  props: {
    einzugsgebiet: Object,
    typ: String
  },
  components: {
    Accordion
  },
  emits: [

  ],
  setup(props, {emit}){

    onMounted(() => {
      
    });



    return {
      Constants
    }

  }
}
</script>